import { TenantTypes } from './auth';

export const buildUrl =
  (rootUrl: string, seperator = '/') =>
  (uriSegment: string) => {
    const normalizedRootUrl = rootUrl.replace(/[/\\]*$/g, '');
    const normalizedUriSegment = uriSegment.replace(/^[/\\]*/g, '');
    const toReturn = `${normalizedRootUrl}${seperator}${normalizedUriSegment}`;
    return toReturn;
  };

export const addLeadingSlashToPath = (
  path: string,
  seperatorToReplaceWith = '/',
): string => {
  return ('/' + path).replace(/^[\\/]+/g, seperatorToReplaceWith);
};

export const removeLeadingSlashFromPath = (path: string): string => {
  return path.replace(/^[\\/]+/, '');
};

export const addTrailingSlashToPath = (
  path: string,
  seperatorToReplaceWith = '/',
) => {
  return (path + '/').replace(/[\\/]+$/, seperatorToReplaceWith);
};

export const removeTrailingSlashFromPath = (path: string): string => {
  return path.replace(/[\\/]+$/, '');
};

export const trimSlashesFromPath = (path: string): string => {
  return removeLeadingSlashFromPath(removeTrailingSlashFromPath(path));
};

export const removeMultipleSlashesFromPath = (path: string): string => {
  return path.replace(/(?<!:)\/{2,}/g, '/');
};

const joinPathsInternal = (seperatorToReplaceWith: string, paths: string[]) => {
  if (paths.length === 0) {
    return '';
  }
  if (paths.length === 1) {
    return paths[0];
  }
  const joinedPaths = paths
    .map((entry, index) => {
      if (index === 0) {
        return removeTrailingSlashFromPath(entry);
      } else if (index === paths.length - 1) {
        return removeLeadingSlashFromPath(entry);
      }
      return trimSlashesFromPath(entry);
    })
    .join(seperatorToReplaceWith);
  return removeMultipleSlashesFromPath(joinedPaths);
};

export const joinPaths = (...paths: string[]): string => {
  return joinPathsInternal('/', paths);
};

export const __joinPathsWindows = (...paths: string[]): string => {
  return joinPathsInternal('\\', paths);
};

export const extractTenantTypeFromTenantCode = (tenantCode: string) => {
  const tenantType = tenantCode.split('-')?.[0] || '';
  const availableTenantType = TenantTypes.find(
    (each) => each.toLowerCase() === tenantType.toLowerCase(),
  );

  return availableTenantType;
};
